import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const fileType: Array<RouteConfig> = [
    {
        path: 'data-manage/file-type',
        name: 'fileType',
        redirect: { name: 'fileTypeSettings' },
        meta: {
            menuMatch: 'fileTypeSettings',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'settings',
                name: 'fileTypeSettings',
                component: () => import(`@/${BASE_PATH}/fileType/FileType.vue`),
                meta: {
                    index: '6',
                },
            },
        ],
    },
];
export default fileType;